import { Collection } from 'modules/core/lib/mobx-rest'

import Event from 'modules/posts/store/models/Event'

class Events extends Collection<Event> {
  get cacheKey(): string {
    return 'events'
  }

  model() {
    return Event
  }
}

const singleton: Events = new Events()

export default singleton
